<script>
	import { navigate } from "svelte-routing";

	export let items = [];
	export let activeTab;
	export let activeTabValue = activeTab ?? 1;
	export let detailData;
	export let issues;
	export let slides;
	export let options;
	export let img_url;
	export let fetchIssue;
	export let compareMode;
	export let selectCarSection;
	export let fetchApprovedIssues;
	export let unique;
	export let data;
	export let width = "fit-content";
	export let fetchServiceData;
	export let fetchJobs;
	export let fetch;
	export let vehicleId;
	export let hideTabBar = false;

	//when click on the tab, it will change the detail
	const handleClick = (tabValue) => () => {
		if (fetchApprovedIssues) {
			const issueType = tabValue === 1 ? "1" : "3";
			fetchApprovedIssues(issueType);
		}
		if (fetchServiceData) {
			fetchServiceData(tabValue - 1);
		}

		if (fetchJobs) {
			fetchJobs(tabValue);
		}
		if (fetch) {
			fetch(tabValue);
		}
		activeTabValue = tabValue;
	};
</script>

{#if !hideTabBar}
	<ul>
		<!-- changes the label value based on active tab -->
		{#each items as item}
			<li
				style="width: fit-content; min-width: {width};"
				class={activeTabValue === item.value
					? "active"
					: compareMode
						? "disabled-li"
						: ""}
			>
				<span on:click={handleClick(item.value)} on:keyup={() => {}}
					>{item.label}</span
				>
			</li>
		{/each}
	</ul>
{/if}
{#each items as item}
	{#if activeTabValue == item.value}
		<div class="box">
			<svelte:component
				this={item.component}
				{detailData}
				{...$$props}
				{issues}
				{slides}
				{img_url}
				{fetchIssue}
				{items}
				{options}
				{activeTab}
				{selectCarSection}
				{fetchApprovedIssues}
				{unique}
				{data}
				{vehicleId}
			/>
		</div>
	{/if}
{/each}

<style>
	.box {
		margin-bottom: 10px;
		border-top: 0;
	}
	ul {
		display: flex;
		flex-wrap: wrap;
		padding-left: 0;
		margin-bottom: 20px;
		list-style: none;
		border-bottom: 2px solid #f6f7f9;
	}

	li {
		text-align: center;
		position: relative;
		bottom: -2px;
		border-bottom: 2px solid transparent;
	}

	li:hover {
		border-bottom: 2px solid #ededed;
	}

	li span {
		display: block;
		padding: 0.5rem 1rem;
		cursor: pointer;
		color: #595959;
		transition: 100ms;
		text-wrap: nowrap;
		text-align: center;
	}

	span:hover {
		color: #1e1e1e;
	}

	.active span {
		color: black;
		font-weight: bold;
	}

	li.active {
		border-bottom: 2px solid #003bed;
	}

	.disabled-li span {
		pointer-events: none;
		color: #c1c3c7;
		cursor: none;
		-webkit-user-select: none; /* Chrome all / Safari all */
		-moz-user-select: none; /* Firefox all */
		-ms-user-select: none; /* IE 10+ */
		user-select: none;
		border-bottom-color: #ededed;
	}
	li.disabled-li {
		pointer-events: none;
		color: #c1c3c7;
		cursor: none;
		-webkit-user-select: none; /* Chrome all / Safari all */
		-moz-user-select: none; /* Firefox all */
		-ms-user-select: none; /* IE 10+ */
		user-select: none;
		border-bottom-color: #f6f7f9;
	}
</style>
